const AudioCtx = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext

let ctx: AudioContext | null = null

function getCtx(): AudioContext {
  if (!ctx) ctx = new AudioCtx()
  if (ctx.state === 'suspended') ctx.resume()
  return ctx
}

function playTone(freq: number, duration: number, type: OscillatorType = 'sine', volume = 0.12) {
  try {
    const c = getCtx()
    const osc = c.createOscillator()
    const gain = c.createGain()
    osc.type = type
    osc.frequency.setValueAtTime(freq, c.currentTime)
    gain.gain.setValueAtTime(volume, c.currentTime)
    gain.gain.exponentialRampToValueAtTime(0.001, c.currentTime + duration)
    osc.connect(gain).connect(c.destination)
    osc.start()
    osc.stop(c.currentTime + duration)
  } catch { /* silent fail */ }
}

export function playClick() {
  playTone(800, 0.08, 'square', 0.06)
}

export function playTick() {
  playTone(1200, 0.03, 'sine', 0.08)
}

export function playSpinStart() {
  const c = getCtx()
  try {
    const notes = [523, 659, 784]
    notes.forEach((f, i) => {
      const osc = c.createOscillator()
      const gain = c.createGain()
      osc.type = 'sine'
      osc.frequency.setValueAtTime(f, c.currentTime + i * 0.08)
      gain.gain.setValueAtTime(0.1, c.currentTime + i * 0.08)
      gain.gain.exponentialRampToValueAtTime(0.001, c.currentTime + i * 0.08 + 0.15)
      osc.connect(gain).connect(c.destination)
      osc.start(c.currentTime + i * 0.08)
      osc.stop(c.currentTime + i * 0.08 + 0.15)
    })
  } catch { /* silent */ }
}

export function playWin() {
  const c = getCtx()
  try {
    const melody = [523, 659, 784, 1047, 784, 1047]
    melody.forEach((f, i) => {
      const osc = c.createOscillator()
      const gain = c.createGain()
      osc.type = 'sine'
      osc.frequency.setValueAtTime(f, c.currentTime + i * 0.12)
      gain.gain.setValueAtTime(0.15, c.currentTime + i * 0.12)
      gain.gain.exponentialRampToValueAtTime(0.001, c.currentTime + i * 0.12 + 0.25)
      osc.connect(gain).connect(c.destination)
      osc.start(c.currentTime + i * 0.12)
      osc.stop(c.currentTime + i * 0.12 + 0.25)
    })
  } catch { /* silent */ }
}

export function playLose() {
  const c = getCtx()
  try {
    const notes = [400, 350, 300]
    notes.forEach((f, i) => {
      const osc = c.createOscillator()
      const gain = c.createGain()
      osc.type = 'triangle'
      osc.frequency.setValueAtTime(f, c.currentTime + i * 0.15)
      gain.gain.setValueAtTime(0.08, c.currentTime + i * 0.15)
      gain.gain.exponentialRampToValueAtTime(0.001, c.currentTime + i * 0.15 + 0.2)
      osc.connect(gain).connect(c.destination)
      osc.start(c.currentTime + i * 0.15)
      osc.stop(c.currentTime + i * 0.15 + 0.2)
    })
  } catch { /* silent */ }
}

